import request from "@/utils/request";

export function login(account, password) {
  const formData = new FormData();
  formData.append("account", account);
  formData.append("password", password);
  
  return request({
    url: "/user/login",
    method: "post",
    data: formData,
  });
}

export function getPrivacyProtocol() {
  const formData = new FormData();
  formData.append("type", "1"); 
  return request({
    url: "/protocol/index",
    method: "post",
    data: formData,
  });
}

export function activateAccount() {
  return request({
    url: "/user/activate",
    method: "post",
  });
}